if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector('form')) {
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      } else {
        this.querySelector('[name=id]').disabled = false;
        this.querySelector('button[type=submit]').addEventListener('click', this.onSubmitHandler.bind(this));
      }

      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';

      const selects = document.querySelectorAll('.upgrade-select');
      const inputsContainer = document.querySelector('#product-upgrades');

      selects.forEach((select) => {
        select.addEventListener('change', (event) => {
          const select = event.target;
          const hiddenInputId = select.getAttribute('data-hidden-input');
          let hiddenInput = document.getElementById(hiddenInputId);

          if (!hiddenInput) {
            hiddenInput = document.createElement('input');
            hiddenInput.type = 'hidden';
            hiddenInput.id = hiddenInputId;
            hiddenInput.name = "id[]";
            hiddenInput.classList.add('product-variant-id');
            inputsContainer.appendChild(hiddenInput);
          }

          if (select.value) {
            hiddenInput.value = select.value;
          } else {
            if (hiddenInput) {
              inputsContainer.removeChild(hiddenInput);
            }
          }
        });
      });
    }

    generateUniqueBundleId() {
      var timestamp = new Date().getTime();
      const randomTimeNum = timestamp % 10000;
      var randomNum = Math.floor(Math.random() * 1000);
      return randomTimeNum.toString().padStart(4, '0') + '-' + randomNum;
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      // Identify if upgrades are chosen
      const upgradeInputs = this.form.querySelectorAll('input[name="id[]"]');
      const upgradesSelected = upgradeInputs.length > 0;

      // Capture the main product ID
      const mainProductIdInput = this.form.querySelector('[name="id"]');
      const mainProductId = mainProductIdInput ? mainProductIdInput.value : null;

      // If no main product ID found, we cannot add the main product
      if (!mainProductId) {
        console.error("No main product 'id' field found in the form.");
        this.handleErrorMessage("No main product selected.");
        this.finalizeRequest();
        return;
      }

      if (upgradesSelected) {
        this.bundleId = this.generateUniqueBundleId();
        console.log("Upgrades selected. Adding upgrades first...");

        this.addUpgrades(upgradeInputs)
          .then((upgradesSuccess) => {
            if (!upgradesSuccess) {
              console.log("Upgrades failed, not adding main product.");
              this.finalizeRequest();
              return;
            }
            console.log("Upgrades added successfully, now adding main product...");
            this.addMainProduct(mainProductId);
          });
      } else {
        // No upgrades, just add main product without bundleId
        this.bundleId = null;
        console.log("No upgrades selected. Adding main product only...");
        this.addMainProduct(mainProductId);
      }
    }

    addUpgrades(upgradeInputs) {
      const upgradesConfig = fetchConfig('javascript');
      upgradesConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete upgradesConfig.headers['Content-Type'];

      const upgradesFormData = new FormData();
      // Each selected upgrade variant as id[]
      upgradeInputs.forEach((input) => {
        upgradesFormData.append('id[]', input.value);
      });

      // Add bundleId if we have one
      if (this.bundleId) {
        upgradesFormData.append('properties[bundleId]', this.bundleId);
      }

      if (this.cart) {
        upgradesFormData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        upgradesFormData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      upgradesConfig.body = upgradesFormData;

      return fetch(`${routes.cart_add_url}`, upgradesConfig)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form-upgrade',
              errors: response.description,
              message: response.message
            });
            this.handleErrorMessage("Error adding upgrades: " + response.description);
            this.error = true;
            return false;
          } else {
            if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form-upgrade'});
            this.error = false;
            this.cart.renderContents(response);
            return true;
          }
        })
        .catch((e) => {
          console.error(e);
          this.handleErrorMessage("Error adding upgrades.");
          this.error = true;
          return false;
        });
    }

    addMainProduct(mainProductId) {
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      // Create a new FormData specifically for the main product
      const mainFormData = new FormData();
      mainFormData.append('id', mainProductId);

      if (this.bundleId) {
        mainFormData.append('properties[bundleId]', this.bundleId);
      }

      if (this.cart) {
        mainFormData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        mainFormData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      config.body = mainFormData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form', 
              productVariantId: mainProductId, 
              errors: response.description, 
              message: response.message
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (soldOutMessage) {
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
            }
            this.error = true;
          } else {
            if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: mainProductId});
            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => { this.cart.renderContents(response) }, 0);
              }, { once: true });
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.finalizeRequest();
        });
    }

    finalizeRequest() {
      this.submitButton.classList.remove('loading');
      if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      this.querySelector('.loading-overlay__spinner').classList.add('hidden');
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}